<div class="revoked-dialog text-center">
  <ng-container *ngIf="single; else many">
    <div class="d-flex justify-content-center mb-6">
      <app-badge-tile [badge]="single.badge" size="lg" [earned]="false" [showProgress]="false"></app-badge-tile>
    </div>
    <h3 class="font-weight-bolder mb-2">{{ '::AchievementRevoked' | abpLocalization }}</h3>
    <div class="font-size-h5 font-weight-bold text-dark-75 mb-2">{{ single.badge.name }}</div>
    <p class="text-muted mb-6" *ngIf="single.reason">{{ single.reason }}</p>
  </ng-container>

  <ng-template #many>
    <h3 class="font-weight-bolder mb-6">
      {{ '::AchievementsRevoked' | abpLocalization: ('' + revoked.length) }}
    </h3>
    <div class="revoked-list text-left mb-6">
      <div class="revoked-item d-flex align-items-center" *ngFor="let item of revoked">
        <app-badge-tile [badge]="item.badge" size="sm" [earned]="false" [showProgress]="false"></app-badge-tile>
        <div class="ml-4 min-w-0">
          <div class="font-weight-bold text-dark-75 text-truncate" [title]="item.badge.name">{{ item.badge.name }}</div>
          <div class="text-muted font-size-sm" *ngIf="item.reason">{{ item.reason }}</div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="revoked-actions">
    <button type="button" class="btn btn-primary font-weight-bold" (click)="seeAll()">
      <i class="bi bi-trophy"></i> {{ '::SeeAllAchievements' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-light font-weight-bold" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
